import { Grid } from "@mui/material";
import HeadersUsersTable from "./HeadersUsersTable";
import UsersTable from "./UsersTable";
import { useSuperAdminUsers } from "../../../context/SuperAdmin/UsersContext";
import { Spinner } from "../../Loading/Spinner";
import CreateUserModal from "./CreateUserModal";
import DeleteUserModal from "./DeleteUserModal";
import EditUserModal from "../Organization/Users/EditUserModal";

const UsersPanel = () => {
  const {
    isLoadingUsers,
    isEditing,
    isEditModalOpen,
    toggleEditModal,
    usuarioSeleccionado,
    userEdit,
  } = useSuperAdminUsers();

  if (isLoadingUsers) {
    return <Spinner msg="Cargando por favor espere..." />;
  }
  return (
    <>
      {/* Crear plan */}
      <Grid item>
        <HeadersUsersTable />
      </Grid>

      {/* Tabla de usuarios */}
      <Grid item>
        <UsersTable />
      </Grid>

      {/* Modal para crear usuario */}
      <Grid item>
        <CreateUserModal />
      </Grid>

      {/* Modal para borrar usuario */}
      <Grid item>
        <DeleteUserModal />
      </Grid>

      {/* Modal para editar usuario */}
      {
        <Grid item>
          <EditUserModal
            isEditModalOpen={isEditModalOpen}
            isEditing={isEditing}
            toggleEditModal={toggleEditModal}
            usuarioSeleccionado={usuarioSeleccionado}
            userEdit={userEdit}
          />
        </Grid>
      }
    </>
  );
};

export default UsersPanel;
